<ng-container *ngIf="selectedItem; else placeholder">
  <div class="detail-loading" *ngIf="isLoadingDetails">
    <bz-loading [size]="'xl'"></bz-loading>
  </div>
  <main class="main" *ngIf="!isLoadingDetails">
    <div class="task">
      <span class="task-title bk-bizagi-detail__title">
        <bzg-icon class="bk-bizagi-icon" [nameIcon]="'icon-bizagi-data-22'" [size]="22"></bzg-icon>
        {{ selectedItem.DisplayName }}
      </span>
    </div>
    <div class="task-meta-container">
      <div class="task-meta">
        <strong>{{ 'BASEKNOWLEDGECATALOG.FREQUENCY' | translate }}:</strong> {{ getFrecuencyTranslated(selectedItem.Frequency) }} |
        <strong>{{ 'BASEKNOWLEDGECATALOG.START_DATE' | translate }}:</strong> {{ selectedItem.StartDate | showDateFormat: 2 }}
      </div>
    </div>
    <!-- Mensaje cuando hay subsets con DataNotFound -->
    <div *ngIf="shouldShowDataNotFoundMessage() && kbLearnedDetails?.length > 0" class="kb-warning">
      <div class="kb-warning-content">
        <bzg-icon [nameIcon]="'warning'" [size]="24" class="bz-space--inline-m bz-icon-color--warning"></bzg-icon>
        <div style="flex:1;">
          <div class="title">{{ 'BASEKNOWLEDGECATALOG.SUBSET.NO_DATA_TITLE' | translate }}</div>
          <div class="text">
            {{ 'BASEKNOWLEDGECATALOG.SUBSET.NO_DATA_MESSAGE' | translate }}
          </div>
        </div>
      </div>
    </div>
    <!-- Mensaje para reintentar -->
    <div *ngIf="hasFailedSubsets() && kbLearnedDetails?.length > 0" class="kb-warning">
      <div class="kb-warning-content">
        <bzg-icon [nameIcon]="'warning'" [size]="24" class="bz-space--inline-m bz-icon-color--warning"></bzg-icon>
        <div style="flex:1;">
          <div class="title">{{ getRetryWarningTitleKey() | translate }}</div>
          <div class="text">
            {{ getRetryWarningMessageKey() | translate }}
          </div>
        </div>
        <div class="content-button-warning">
          <button class="refresh-button warning-refresh-button" [title]="'BASEKNOWLEDGECATALOG.RETRY' | translate" (click)="onRefreshEntity(selectedItem, $event)">
            <bzg-icon class="refresh-icon refresh-icon-custom" [nameIcon]="'icon-refresh'" [size]="16"></bzg-icon>
            <span class="button-text">{{ 'BASEKNOWLEDGECATALOG.RETRY' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
    <!-- Mensaje para subsets eliminados -->
    <bzg-message *ngIf="hasDeletedSubsets() && !isDeletedWarningClosed" 
                 class="deleted-warning-message" 
                 [showCloseBtn]="true" 
                 [status]="'warning'"
                 (closed)="onCloseDeletedWarning()">
      {{ 'BASEKNOWLEDGECATALOG.SUBSET.DELETED_WARNING' | translate }}
    </bzg-message>
    <section class="entities">
      <div *ngFor="let entity of kbLearnedDetails; trackBy: trackByEntity" class="entity-card">
        <div class="entity-container-header">
          <div class="entity-left">
            <span class="entity-label">{{ 'BASEKNOWLEDGECATALOG.ENTITY' | translate }}:</span>
            <div class="entity-content">
              <bzg-icon class="bk-bizagi-icon" [nameIcon]="'icon-entity'" [size]="16"></bzg-icon>
              <span class="entity-displayName">{{ entity.DisplayName }}</span>
            </div>
          </div>
          <span class="subsets-counter" *ngIf="getVisibleSubsets(entity).length > 0 && !shouldShowNoSubsetsForBizagiData(entity)">{{ getVisibleCompletedProgress(entity) }}</span>
        </div>
        <p class="subsets-label">{{ 'BASEKNOWLEDGECATALOG.SUBSET.TITLE' | translate }}:</p>
        <ul *ngIf="getVisibleSubsets(entity).length > 0 && !shouldShowNoSubsetsForBizagiData(entity)" class="subsets-list">
          <li *ngFor="let subset of getVisibleSubsets(entity); trackBy: trackBySubset" class="subset-item">
            <div class="subset-name-container">
              <span [ngClass]="{'subset-deleted-name': subset.IsDeleted}">{{ subset.DisplayName }}</span>
              <span *ngIf="subset.IsDeleted" class="removed-badge">
                ({{ 'BASEKNOWLEDGECATALOG.SUBSET.REMOVED' | translate }})
              </span>
            </div>
            <div class="subset-right">
              <span class="status-subset" [ngClass]="statusSubSetColors(subset.Status)">{{ getStatusTranslated(subset.Status) }}</span>
            </div>
          </li>
        </ul>
        <div class="subsets-no-records" *ngIf="getVisibleSubsets(entity).length == 0 || shouldShowNoSubsetsForBizagiData(entity)">
          <img class="subsets-image-no-records" src="assets/img/no_found.png">
          <span>
            {{ getNoSubsetsMessage(entity) | translate }}
          </span>
        </div>
      </div>
    </section>
  </main>
</ng-container>
<ng-template #placeholder>
  <div class="main placeholder">
    <img class="subsets-image-no-records" src="assets/img/no_found.png">
    <p>{{ 'BASEKNOWLEDGECATALOG.SELECT_ITEM' | translate: { default: 'Select an item to view details.' } }}</p>
  </div>
</ng-template>